import { TProjectConfigurationGeneralItem } from 'pages/common/types';

const getFullIOptionPrice = (product: TProjectConfigurationGeneralItem) => {
  const { price, quantity } = product;

  return price * quantity;
};

export const getCheapestProduct = (products: TProjectConfigurationGeneralItem[]) =>
  [...products].sort((a, b) => getFullIOptionPrice(a) - getFullIOptionPrice(b))[0];
